
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
@Component
export default class SelectAir extends Vue {
  private indexList: any = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "W",
    "X",
    "Y",
    "Z",
  ];
  private airCitys: any = []; // 机场数组
  private airlist: any = []; // 选择的机场数组
  private air: any = ""; // 输入的机场名字
  private $api: any;

  private airports: any = {};

  private async created() {
    const result = await this.$api.httpGet("Membership/TripBookTicket/GetAirportsDic",null);
    if (result.Success) {
      for (let key in result.Data) {
        result.Data[key] = result.Data[key].map(function (item: any) {
          return {
            airportCode: item.AirportCode,
            airportCName: item.AirportCName,
            cityCode: item.CityCode,
            cityCName: item.CityCName,
            isHot: item.IsHot,
            domesticProvince: item.DomesticProvince,
          };
        });
      }
      this.airports = result.Data;
    }
  }

  @Watch("air")
  private onAirChange() {
    // 监听选择的机场
    const that = this;
    const selAir = that.air;
    that.airlist = [];
    if (selAir) {
      for (const i of Object.keys(that.airports)) {
        that.airports[i].forEach((val: any) => {
          if (val.airportCName.indexOf(selAir) > -1) {
            that.airlist.push(val);
          }
        });
      }
    }
  }
  // 确定
  private chooseCity(val: any) {
    this.$emit("input", val);
  }

  private onCancel() {
    this.$emit("input", "");
  }
}
